import React from 'react';
import { ChevronRight, Building, Building2, Users, User } from 'lucide-react';
import { cn } from '../../utils/cn';

/**
 * BreadcrumbNavigation Component
 * Displays the full hierarchy path: Tenants > Organizations > Departments > Teams > Users
 * 
 * @param {Object} hierarchy - The hierarchy path array
 * @param {Function} onNavigate - Callback when clicking a breadcrumb item
 */
const BreadcrumbNavigation = ({ hierarchy = [], onNavigate }) => {
  const getEntityIcon = (type) => {
    switch (type) {
      case 'tenant':
        return <Building className="w-4 h-4" />;
      case 'organization':
        return <Building2 className="w-4 h-4" />;
      case 'department':
        return <Users className="w-4 h-4" />;
      case 'team':
        return <Users className="w-4 h-4" />;
      case 'user':
        return <User className="w-4 h-4" />;
      default:
        return null;
    }
  };

  const getEntityLabel = (entity) => {
    if (!entity) return '';
    return entity.name || entity.tenantName || entity.organizationName || 
           entity.departmentName || entity.teamName || entity.username || 
           entity.fullName || 'Unknown';
  };

  if (hierarchy.length === 0) {
    return (
      <div className="flex items-center gap-2 px-4 py-2 bg-gray-50 border-b">
        <span className="text-sm text-gray-500">No selection</span>
      </div>
    );
  }

  return (
    <nav className="flex items-center gap-2 px-4 py-2 bg-gray-50 border-b overflow-x-auto">
      {hierarchy.map((entity, index) => {
        const isLast = index === hierarchy.length - 1;
        const Icon = getEntityIcon(entity.type);
        
        return (
          <React.Fragment key={`${entity.type}-${entity.id || index}`}>
            <button
              onClick={() => onNavigate && onNavigate(entity, index)}
              className={cn(
                "flex items-center gap-1.5 px-2 py-1 rounded-md text-sm font-medium transition-colors",
                isLast
                  ? "text-gray-900 cursor-default"
                  : "text-gray-600 hover:text-gray-900 hover:bg-gray-100 cursor-pointer"
              )}
              disabled={isLast}
            >
              {Icon && <span className="text-gray-500">{Icon}</span>}
              <span className="truncate max-w-[150px]">{getEntityLabel(entity)}</span>
            </button>
            {!isLast && (
              <ChevronRight className="w-4 h-4 text-gray-400 flex-shrink-0" />
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
};

export default BreadcrumbNavigation;

